import React, { useState, useRef, useEffect } from 'react';

function UserDropdown({ user, handleLogout }) {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef();

  const toggleDropdown = () => setIsOpen(prev => !prev);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={menuRef}>
      <div
        className="flex items-center cursor-pointer space-x-2"
        onClick={toggleDropdown}
      >
        <img
          className="h-10 w-10 rounded-full object-cover border border-gray-300"
          src={`https://ui-avatars.com/api/?name=${encodeURIComponent(user.name)}`}
          alt="User profile"
        />
        <span className="hidden md:inline text-gray-700 font-medium">{user.name}</span>
        <svg className="h-4 w-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-50">
          <button
            onClick={handleLogout}
            className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 font-semibold text-left"
          >
            Logout
          </button>
        </div>
      )}
    </div>
  );
}

export default UserDropdown;
